import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { STEP_NAMES, STEP_ORDER } from '../ReportIllicitContent.constants'

import translations from './useReportIllicitContentSteps.translations'

export function useReportIllicitContentSteps() {
  const i18n = useI18n()

  const currentStep = ref<(typeof STEP_NAMES)[keyof typeof STEP_NAMES]>(
    STEP_NAMES.CONTENT,
  )

  const stepperSteps = computed(() => [
    {
      name: STEP_NAMES.CONTENT,
      label: i18n(translations.stepContent),
    },
    {
      name: STEP_NAMES.ABOUT,
      label: i18n(translations.stepAbout),
    },
    {
      name: STEP_NAMES.DECLARATION,
      label: i18n(translations.stepDeclaration),
    },
  ])

  const isFirstStep = computed(() => currentStep.value === STEP_NAMES.CONTENT)
  const isLastStep = computed(
    () => currentStep.value === STEP_NAMES.DECLARATION,
  )

  function goToPreviousStep() {
    const currentIndex = STEP_ORDER.indexOf(currentStep.value)

    if (currentIndex > 0) {
      currentStep.value = STEP_ORDER[currentIndex - 1]
    }
  }

  function goToNextStep() {
    const currentIndex = STEP_ORDER.indexOf(currentStep.value)

    if (currentIndex < STEP_ORDER.length - 1) {
      currentStep.value = STEP_ORDER[currentIndex + 1]
    }
  }

  return {
    currentStep,
    stepperSteps,
    isFirstStep,
    isLastStep,
    goToPreviousStep,
    goToNextStep,
  }
}
